import {
  CallToAction,
  Faq,
  Features,
  Hero,
  HowItWorks,
  UseCases,
} from '@features/landing/components'

export function HomePage() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Features />
      <UseCases />
      <Faq />
      <CallToAction />
    </>
  )
}
